<ion-header mode="ios">
  <div class="pdf-header">

    <!-- Left: file name -->
    <span class="pdf-header-title">{{ modalTitle }}</span>

    <!-- Center: all controls -->
    <div class="pdf-controls">

      <!-- Page navigation -->
      <div class="toolbar-group">
        <ion-button fill="clear" size="small" aria-label="Previous page"
          [disabled]="currentPage <= 1 || totalPages === 0"
          (click)="prevPage()">
          <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
        </ion-button>
        <span class="page-indicator" *ngIf="totalPages > 0">
          {{ currentPage }} / {{ totalPages }}
        </span>
        <ion-button fill="clear" size="small" aria-label="Next page"
          [disabled]="currentPage >= totalPages || totalPages === 0"
          (click)="nextPage()">
          <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
        </ion-button>
      </div>

      <!-- Divider -->
      <div class="toolbar-divider" aria-hidden="true"></div>

      <!-- Zoom -->
      <div class="toolbar-group">
        <ion-button fill="clear" size="small" aria-label="Zoom out" [disabled]="zoom <= 0.5" (click)="zoomOut()">
          <ion-icon slot="icon-only" name="remove-outline"></ion-icon>
        </ion-button>
        <span class="zoom-indicator">{{ zoomPercent }}%</span>
        <ion-button fill="clear" size="small" aria-label="Zoom in" [disabled]="zoom >= 3.0" (click)="zoomIn()">
          <ion-icon slot="icon-only" name="add-outline"></ion-icon>
        </ion-button>
      </div>

      <!-- Divider -->
      <div class="toolbar-divider" aria-hidden="true"></div>

      <!-- Download and Print -->
      <div class="toolbar-group">
        <ion-button fill="clear" size="small" aria-label="Download" (click)="download()">
          <ion-icon slot="icon-only" name="download-outline"></ion-icon>
        </ion-button>
        <ion-button fill="clear" size="small" aria-label="Print" (click)="print()">
          <ion-icon slot="icon-only" name="print-outline"></ion-icon>
        </ion-button>
      </div>
    </div>

    <!-- Right: close -->
    <ion-button class="pdf-header-close" fill="clear" size="small" aria-label="Close" (click)="close()">
      <ion-icon slot="icon-only" name="close-outline"></ion-icon>
    </ion-button>

  </div>
</ion-header>

<ion-content>
  <div #pdfContainer class="pdf-touch-container">
    <pdf-viewer
      *ngIf="file"
      [src]="file"
      [rotation]="0"
      [original-size]="false"
      [show-all]="true"
      [fit-to-page]="true"
      [zoom]="zoom"
      [zoom-scale]="'page-height'"
      [stick-to-page]="false"
      [page]="currentPage"
      [external-link-target]="'blank'"
      [autoresize]="true"
      [show-borders]="false"
      (after-load-complete)="onLoaded($event)"
      (pageChange)="onPageChange($event)"></pdf-viewer>
  </div>
</ion-content>
